module.exports = __webpack_public_path__ + "static/media/avax.9556dc3a.svg";